import {useEffect} from 'react';
import {useGtagEventLocation} from 'hooks/analytics/gtag/helpers/useGtagEventLocation';
import {useGtagUserData} from 'hooks/analytics/gtag/helpers/useGtagUserData';
import {sendGtagEvent} from 'hooks/analytics/gtag/helpers';
import {EventPortalName, TOwoxPage} from 'modules/google-analytics/constants';

const EXCLUDE_OWOX_PAGES: TOwoxPage[] = [
    'BRAND_PAGE',
    'CATALOG_VINOTHEQUE',
    'VINOTHEQUE_PAGE',
    'CATALOG_ARTICLES',
    'ARTICLE_PAGE',
    'PRODUCT_PAGE',
    'PRODUCT_REVIEWS',
];

export const usePageViewGtag = (
    pageType?: TOwoxPage,
    portalName: string = EventPortalName.Shop,
    categoryName?: string,
    itemName?: string,
) => {
    const {eventLocation} = useGtagEventLocation();

    const gtagUserData = useGtagUserData({
        pageType,
        portalName,
        categoryName,
        itemName,
    });

    if (!categoryName) {
        delete gtagUserData.categoryName;
    }
    if (!itemName) {
        delete gtagUserData.itemName;
    }

    const shouldSkipGlobalViewSend = eventLocation && EXCLUDE_OWOX_PAGES.includes(eventLocation) && !pageType;

    useEffect(() => {
        if (shouldSkipGlobalViewSend) {
            return;
        }
        sendGtagEvent(gtagUserData);
    }, [gtagUserData, shouldSkipGlobalViewSend]);
};
